// TNBEWEB-1945 — styling for HTML authored in the screen editor's Text node.
//
// The app-wide reset (styles/reset.scss) strips list markers and flattens
// h1–h6 to the body font-size, and the browser's own anchor styling (blue +
// underline) overrode whatever colour the author set. Both are correct for the
// app chrome and wrong for authored rich text, so re-establish them HERE only,
// scoped to the rendered text-node content.
//
// Selectors are written as `span.richText …` so they outrank the
// `.fix_overflow *` / `.fix_overflow ul` rules in Text.module.scss (equal
// specificity would leave the winner up to stylesheet order).
//
// Mirrors editor/src/components/HtmlContent/HtmlContent.module.scss — keep both
// in sync.

span.richText {
  // Links take the text's colour and decoration instead of the browser's blue
  // underline. An underline set on the node itself is drawn by the ancestor and
  // still shows through — only the anchor's own default is suppressed.
  a {
    color: inherit;
    text-decoration: none;
    cursor: pointer;
  }

  ul,
  ol {
    margin: 0;
    padding-left: 1.5em;
    list-style-position: outside;
  }

  ul { list-style-type: disc; }
  ul ul { list-style-type: circle; }
  ul ul ul { list-style-type: square; }
  ol { list-style-type: decimal; }

  li {
    margin: 0;
    list-style-type: inherit;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    font-weight: 700;
    line-height: 1.25;
  }

  h1 { font-size: 2em; }
  h2 { font-size: 1.5em; }
  h3 { font-size: 1.17em; }
  h4 { font-size: 1em; }
  h5 { font-size: 0.83em; }
  h6 { font-size: 0.67em; }

  blockquote {
    margin: 0;
    padding-left: 1em;
    border-left: 0.2em solid currentcolor;
    opacity: 0.85;
  }

  pre,
  code,
  kbd,
  samp {
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  }

  pre {
    margin: 0;
    white-space: pre-wrap;
  }

  hr {
    margin: 0.5em 0;
    border: none;
    border-top: 1px solid currentcolor;
    opacity: 0.4;
  }

  // `.fix_overflow *` blanket-disables decorations with !important, which also
  // erased the ones the author asked for. Restore them explicitly.
  u,
  ins {
    text-decoration: underline !important;
  }

  s,
  del {
    text-decoration: line-through !important;
  }
}
